import { APIClient } from '@convergence/client';
import { config } from '../config';

export const client = new APIClient(
  config.VITE_API_ENDPOINT,
  config.VITE_SUBSCRIPTION_ENDPOINT
);
